import { CreatorFunctions } from "@microchip/melody-automodule-interface";
import { State } from "../generated_module/src/types/State";

export const getCreatorFunctions = (): CreatorFunctions => {
    return {
        shouldImport: shouldImport,
        getCreatorImportArgs: getCreatorImportArgs,
    };
};

const shouldImport = (importKey: string, state: State): boolean => {
    switch (importKey) {
        case "I2C":
            return false;
        default:
            return true;
    }
};

const getCreatorImportArgs = (importKey: string, state: State): any | undefined => {
    return undefined;
};
